import React, { useState } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { LuChevronLeft } from "react-icons/lu";
import { RxCross1 } from "react-icons/rx";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

export default function SeeAllImages({ images = [], setSeeAllclicked }) {
    const [currentImage, setCurrentImage] = useState(0);

    // Handle clicking the previous image
    const onClickPrev = () => {
        if (currentImage > 0) {
            setCurrentImage(currentImage - 1);
        }
    };

    // Handle clicking the next image
    const onClickNext = () => {
        if (currentImage < images.length - 1) {
            setCurrentImage(currentImage + 1);
        }
    };

    // If images are empty, display a fallback UI
    if (!images.length) {
        return (
            <div className="tw-fixed tw-top-0 tw-left-0 tw-h-screen tw-w-screen tw-bg-black tw-flex tw-items-center tw-justify-center tw-text-white tw-z-[101]">
                <p className="tw-text-lg sm:tw-text-xl">No Images Available</p>
                <button
                    onClick={() => setSeeAllclicked(false)}
                    className="tw-absolute tw-top-4 sm:tw-top-10 tw-right-4 sm:tw-right-10 tw-bg-red-500 tw-text-white tw-px-4 tw-py-2 tw-rounded-md tw-cursor-pointer tw-shadow-lg tw-transition-all tw-duration-200 hover:tw-bg-red-600"
                >
                    Close
                </button>
            </div>
        );
    }

    return (
        <div className="tw-fixed tw-z-[101] tw-top-0 tw-left-0 tw-h-screen tw-w-screen tw-bg-black">
            <div className="tw-relative tw-h-full tw-w-full">
                <Zoom>
                    <img
                        src={images[currentImage]?.image_url || images[currentImage]?.wasabi_key}
                        alt={`Image ${currentImage + 1}`}
                        className="tw-h-full tw-w-full tw-object-contain tw-transition-transform tw-duration-300 tw-ease-in-out hover:tw-scale-110 sm:hover:tw-scale-150"
                        onError={(e) => {
                            e.target.src = "/path/to/placeholder-image.png";
                        }}
                    />
                </Zoom>
                {/* Previous Button */}
                {currentImage != 0 && (
                    <span
                        onClick={onClickPrev}
                        className="tw-rounded-full tw-absolute tw-left-4 sm:tw-left-10 tw-top-1/2 tw-transform tw--translate-y-1/2 tw-bg-white tw-text-black tw-cursor-pointer tw-shadow-lg tw-transition-all tw-duration-200 hover:tw-scale-110"
                    >
                        <FaChevronLeft className="tw-text-[20px] sm:tw-text-[24px] tw-m-2" />
                    </span>
                )}

                {/* Next Button */}
                {currentImage != images.length - 1 && (
                    <span
                        onClick={onClickNext}
                        className="tw-rounded-full tw-absolute tw-right-4 sm:tw-right-10 tw-top-1/2 tw-transform tw--translate-y-1/2 tw-bg-white tw-text-black tw-cursor-pointer tw-shadow-lg tw-transition-all tw-duration-200 hover:tw-scale-110"
                    >
                        <FaChevronRight className="tw-text-[20px] sm:tw-text-[24px] tw-m-2" />
                    </span>
                )}

                {/* Close Button */}
                <span
                    onClick={() => setSeeAllclicked(false)}
                    className="tw-rounded-full tw-absolute tw-right-4 sm:tw-right-10 tw-top-4 sm:tw-top-10 tw-bg-white tw-text-black tw-cursor-pointer tw-shadow-lg tw-transition-all tw-duration-200 hover:tw-scale-110 tw-z-10"
                >
                    <RxCross1 className="tw-text-[20px] sm:tw-text-[24px] tw-m-2" />
                </span>
                {/* <img
                    src="/cross.png"
                    alt="Close"
                    onClick={() => setSeeAllclicked(false)}
                    className="tw-h-[40px] tw-w-[40px] tw-cursor-pointer tw-object-contain tw-absolute tw-right-10 tw-top-10 tw-bg-white tw-rounded-md tw-shadow-md tw-py-2"
                /> */}
                {/* Image Counter */}
                <div className="tw-absolute tw-left-1/2 tw-transform tw--translate-x-1/2 tw-bottom-4 sm:tw-bottom-10 tw-bg-black tw-bg-opacity-80 tw-text-white tw-rounded-lg tw-px-4 tw-py-2 sm:tw-p-5 tw-text-center tw-backdrop-blur-sm">
                    <p className="tw-text-sm sm:tw-text-base tw-font-medium">
                        {currentImage + 1}/{images.length}
                    </p>
                </div>
            </div>
        </div>
    );
}
